query StreamsList($page: Int, $rowsPerPage: Int, $filter: ContentsFilterInput) {
  contents(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      premium
      publishAt
      url
      totalViews
      viewersOnline
      liveState
      tags {
        id
        title
      }
      countryAccess {
        id
        title
      }
      preview {
        id
        url(format: SMALL)
      }
      stream {
        id
        status
        liveConnected
        signal {
          state
          since
          checkedAt
        }
        startAt
        finishAt
        playback {
          hlsUrl
          thumbnailUrl
        }
      }
    }
  }
}
